'use client';
import React, { MutableRefObject, useRef } from 'react';
import { ChangeEvent, useEffect } from 'react';
import cn from 'classnames';

import './SearchBarTextElement.style.scss';

type SearchBarTextElementProps = {
  className?: string;
  value: string;
  onBlur?: (event: ChangeEvent<HTMLInputElement>) => void;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  willFocus?: boolean;
};

function SearchBarTextElement(props: SearchBarTextElementProps) {
  const {
    className = '',
    value,
    onBlur,
    onChange,
    placeholder,
    willFocus
  } = props;
  const ref = useRef() as MutableRefObject<HTMLInputElement>;

  useEffect(() => {
    willFocus && ref.current.focus();
  }, [willFocus]);

  return (
    <input
      className={cn('SearchBarTextElement', className)}
      type='text'
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      ref={ref}
    />
  );
}

export default SearchBarTextElement;
